module.exports = __webpack_public_path__ + "img/europe.f3e71e2e.png";